import styled, { css } from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.neutral.offWhite};
  border: 0 solid ${({ theme }) => theme.palette.neutral.lightGray};
  border-radius: 8px;
  box-shadow: 0 0 24px -8px ${({ theme }) => theme.palette.neutral.charcoal};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  max-width: 350px;
  transform: scale(1);
  transition: 0.5s transform ease-in;
  width: 100%;

  &:hover {
    transform: scale(1.02);
    transition: 0.25s transform ease-in;
  }

  ${({ theme }) => theme.mixins.medium} {
    max-width: 49%;
    width: 49%;
  }

  ${({ theme }) => theme.mixins.smallDevices} {
    max-width: 80vw;
    width: 80vw;

    ${({ mobileMaxWidth }) =>
      mobileMaxWidth &&
      css`
        width: 100%;
      `}
  }

  ${({ theme }) => theme.mixins.small} {
    max-width: 90vw;
    width: 90vw;

    ${({ mobileMaxWidth }) =>
      mobileMaxWidth &&
      css`
        width: 100%;
      `}
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 200px;
  padding: 24px;

  ${({ theme }) => theme.mixins.medium} {
    padding: 16px;
  }
`;

export const Description = styled.div`
  font-size: 12px;
  font-style: italic;
`;

export const ImageHeader = styled.div`
  background-image: url(${({ imageUrl }) => imageUrl});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  height: 200px;
`;

export const Metadata = styled.div`
  font-size: 10px;
  letter-spacing: 2px;
  text-transform: uppercase;
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 4px;
  text-transform: uppercase;

  ${({ theme }) => theme.mixins.medium} {
    font-size: 14px;
    letter-spacing: 2px;
    margin-bottom: 8px;
  }
`;
